import styled from '@emotion/styled';
import { Select } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import tw from 'twin.macro';
import _, { intersection } from 'lodash';
import { MultiSelectionAttribute } from '../MultiSelectionAttribute';
import { formatWord } from 'utils/helperMethods';
import DownSvg from 'assets/svg/Down';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PROMO_SCORECARD_SELECT_LEVEL_DROPDOWN_CHANGED } from 'utils/mixpanelEventNames';
import TruncatedList from 'components/atoms/TruncatedList';

const CustomSelect = styled(Select)`
    ${tw`border border-purpleFont rounded text-[13px] text-headerColor`}
    .ant-select-selector {
        height: 100% !important;
        border: none !important;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        border: none !important;
    }
    .ant-select-arrow {
        ${tw`text-headerColor`}
    }
`;

interface props {
    selectedAttributeName: string;
    setSelectedAttributeName: Function;
    idForRestOfComponentFilterB: any;
    setFilterC: Function;
    setLoadingStateForFilterC: Function;
    setLoadingStateForAttrNames: Function;
    promoScoreCardConfig: any;
    screenFilterConfig: any;
}

function PromoScorecardSelection({
    selectedAttributeName,
    setSelectedAttributeName,
    idForRestOfComponentFilterB,
    setFilterC,
    setLoadingStateForFilterC,
    setLoadingStateForAttrNames,
    promoScoreCardConfig,
    screenFilterConfig,
}: props) {
    const [attributeList, setAttributeList] = useState<any>(() => {
        let list: any = [];
        promoScoreCardConfig.dropDown?.forEach((attrName: any) => {
            list.push({ label: formatWord(attrName), value: attrName });
        });
        return list;
    });
    const [checkedAttributeNames, setCheckAttributeNames] = useState<any>({});
    const [selectionId, setSelectionID] = useState<any>({
        dim1: { ids: [] },
        dim2: { ids: [] },
    });
    const checkedAttributeNamesRef = useRef<any>();

    useEffect(() => {
        //dont do computation on filterb default state with dim1:[],dim2:[]
        if (idForRestOfComponentFilterB.dim1.ids?.length || idForRestOfComponentFilterB.dim2.ids?.length) {
            //setFilterC(idForRestOfComponentFilterB);
            setSelectionID({
                dim1: { ids: [] },
                dim2: { ids: [] },
            });
            setCheckAttributeNames(() => ({}));
            checkedAttributeNamesRef.current = {};
        }
    }, [selectedAttributeName]);

    useEffect(() => {
        //dont do computation on filterb default state with dim1:[],dim2:[]
        if (idForRestOfComponentFilterB.dim1.ids?.length || idForRestOfComponentFilterB.dim2.ids?.length) {
            let intersectionDim1: any;
            let copyOfFilterB = _.cloneDeep(idForRestOfComponentFilterB);
            if (selectionId?.dim1?.ids.length) {
                intersectionDim1 = intersection(idForRestOfComponentFilterB.dim1.ids, selectionId.dim1.ids);
                copyOfFilterB.dim1.ids = intersectionDim1;
                setFilterC(copyOfFilterB);
            } else if (!selectionId?.dim1?.ids.length) {
                setFilterC({});
            }
        } else {
            setFilterC(null);
        }
    }, [selectionId, idForRestOfComponentFilterB]);

    const selectedVariables = useMemo(() => {
        return Object.keys(checkedAttributeNames || {}) || [];
    }, [checkedAttributeNames]);

    return (
        <div className="flex flex-col gap-3">
            <div className="flex gap-4">
                <div>
                    <div className="text-borderGrey font-xs mb-2">Select level of Competition</div>
                    <CustomSelect
                        suffixIcon={
                            <>
                                <DownSvg />
                            </>
                        }
                        disabled={false}
                        //loading={allDimAndAttributeTypeList?.loading}
                        className="dropdown-width-multi-select dropdown-height uniqSelPSCompetitionDropdown"
                        value={selectedAttributeName}
                        options={attributeList}
                        onChange={(val: any, item: any) => {
                            setSelectedAttributeName(item.value);
                            trackEventMixpanel(PROMO_SCORECARD_SELECT_LEVEL_DROPDOWN_CHANGED, {
                                dropdownName: item?.label,
                            });
                        }}
                    />
                </div>
                <div>
                    <div className="text-borderGrey font-xs mb-2">Select Variable</div>
                    <MultiSelectionAttribute
                        screenFilterConfig={screenFilterConfig}
                        attributeType={selectedAttributeName}
                        filterID={idForRestOfComponentFilterB}
                        setSelectionId={setSelectionID}
                        setLoadingStateForFilterCall={setLoadingStateForFilterC}
                        checkedAttributeNames={checkedAttributeNames}
                        setCheckAttributeNames={setCheckAttributeNames}
                        checkedAttributeNamesRef={checkedAttributeNamesRef}
                        setLoadingStateForAttrNames={setLoadingStateForAttrNames}
                    />
                </div>
            </div>
            {/* selected items section */}
            <div className="">
                <TruncatedList items={selectedVariables} labelName="Selected Variable:" maxChars={100} />
            </div>
        </div>
    );
}

export default PromoScorecardSelection;
